import { Permissions } from './permissions';

export class Role {
    Name: string;
    Permissions: Permissions[] = [];

    static mapFromJSON(json) {
        const r = new Role();

        r.Name = json.name;
        if (json.permissions) {
            r.Permissions = json.permissions.map(jsonItem => Permissions.mapFromJSON(jsonItem));
        }

        return r;
    }
}
